<template>
    <v-container fluid mt-12 pl-1 pr-1>
        <v-card light
                class="mx-auto"
                outlined
                elevation="10"
        >

            <v-card-text>

                <!--                <b>{{ $t('result.resultTitle') }} </b>-->
                <!--                <app-highlighted-text>'{{taxonName}}' (ID={{taxonId}})</app-highlighted-text>-->
                <!--                <br>-->




                <b>{{ $t('result.resultAccepted') }} </b> (<span v-if="isFungusApp">{{ $t('structure.TitleFungi') }} </span><span v-else> {{ $t('structure.TitleLichens') }}</span>):
                <app-highlighted-text>{{ currentNames.join(" ● ") }}</app-highlighted-text>
                <br>
                <div v-if="showIndexFungorum"><b>{{ $t('result.resultAccepted') }} </b> (<a :href="queryIndexFungorumURL" target="_blank" style="color:darkblue;" title="Index Fungorum"> Index Fungorum</a>):
                <app-highlighted-text >
                {{ indexFungorumNames[0] }}
            </app-highlighted-text><br></div>



                <b>{{ $t('result.resultSynonyms') }}</b>
                <app-highlighted-text> {{synonyms.join(" ● ")}}</app-highlighted-text>
                <br>
                <b>{{ $t('result.resultVernacular') }} </b>
                <app-highlighted-text> {{vernacularNames.join(" ● ")}}</app-highlighted-text>
                <br>
                <b>{{ $t('result.higherTaxonomy') }} </b>
                <app-highlighted-text> {{higherTaxonomy.join(" ● ").replace(/,/g, ', ')}}</app-highlighted-text>
                <br>
                <b>{{ $t('result.dataBasis') }} </b>


                <app-highlighted-text v-if="$store.state.reliableDataBasis === 'true'">{{$t('result.goodDataBasis')}}
                </app-highlighted-text>
                <app-highlighted-text v-else>{{$t('result.badDataBasis')}}</app-highlighted-text>
                <v-icon right @click="showDataBasisInfo=true">mdi-information</v-icon>
                <app-popup-dialog
                        :title="$t('result.dataBasisInfoHeader')"
                        :text="$t('result.dataBasisInfoText')"
                        :showPopup.sync="showDataBasisInfo"
                        @cancel="showDataBasisInfo=false"
                />
                <br>
                <br>
                <b>{{ $t('result.resultLegend') }} </b>
                <search-color-legend></search-color-legend>

            </v-card-text>


        </v-card>

    </v-container>

</template>

<script>

    import AppHighlightedText from '../AppComponents/AppHighlightedText'
    import SearchColorLegend from './SearchColorLegend'
    import {speciesUrl} from '../../data/app-data'
    import axios from 'axios'
    import {API_ERROR_MESSAGE, TIME_RANGE} from '../../data/constants'
    import AppPopupDialog from '../AppComponents/AppPopupDialog'
    import {indexFungorumAPI} from '../../data/app-data'

    export default {
        name: 'searchResult',
        components: {
            AppHighlightedText,
            SearchColorLegend,
            AppPopupDialog
        },
        data() {
            return {
                currentNames: [],
                synonyms: [],
                vernacularNames: [],
                higherTaxonomy: [],
                indexFungorumNames: [],
                min: TIME_RANGE.min,
                max: TIME_RANGE.max,
                showDataBasisInfo: false,
                showIndexFungorum: false,
                queryIndexFungorumURL: null
            }
        },
        computed: {
            taxonId() {
                return this.$store.state.taxonId
            },
            isFungusApp() {
                return this.$store.getters.isFungusApp
            },
            taxonName() {
                return this.$store.state.taxonName
            },
            protectionAPI() {
                return this.isFungusApp ? speciesUrl.protectionFungus : speciesUrl.protectionLichen
            },
            databasisAPI() {
                return this.isFungusApp ? speciesUrl.dataBasisFungus : speciesUrl.dataBasisLichen
            },
        },
        watch: {
            taxonId() {
                this.getNameVariants()
                this.checkProtectionStatus()
                this.updateUrlParams()
                this.getIndexFungorumInfo()
            }

        },

        methods: {
            updateUrlParams() {
                let url = process.env.BASE_URL + 'search?taxon=' + this.$store.state.taxonId + '&start=' + this.$store.state.yearRange.min + '&end=' + this.$store.state.yearRange.max + '&lang=' + this.$store.state.lang
                this.$store.commit('setQueryURL', url)
            },


            checkProtectionStatus() {

                axios.get(this.databasisAPI + this.taxonId).then((result) => {
                    let res = result.data
                    this.$store.commit('setReliableDataBasis', res[0].label)
                }).catch((error) => {
                    console.log(API_ERROR_MESSAGE, error)
                    this.$store.commit('setReliableDataBasis', 'false')
                })

                axios.get(this.protectionAPI + this.taxonId).then((result) => {
                    let res = result.data
                    this.$store.commit('setTotalListEntries', res.length)
                }).catch((error) => {
                    console.log(API_ERROR_MESSAGE, error)
                    this.$store.commit('setTotalListEntries', 0)
                })


            },


            getFullSpeciesName(nameResult) {
                let taxonAutor = nameResult.taxonAutor === null ? '' : nameResult.taxonAutor
                let fullName = nameResult.taxonName + ' ' + taxonAutor
                return fullName.trim()
            },

            getNameVariants() {
                this.currentNames = []
                this.synonyms = []
                this.vernacularNames = []

                axios.get(speciesUrl.speciesNamesByTaxon + this.taxonId).then((result) => {
                    let res = result.data

                    res.currentNames.forEach(name => {
                        let fullName = this.getFullSpeciesName(name)
                        if (this.currentNames.includes(fullName)) {
                            //pass
                        } else {
                            this.currentNames.push(fullName + ' (ID=' + name.taxonId + ')')
                        }

                    })
                    this.$store.commit('setCurrentName', this.currentNames[0])


                    res.synonyms.forEach(name => {
                        let fullName = this.getFullSpeciesName(name)
                        this.synonyms.push(fullName + ' (ID=' + name.taxonId + ')')
                    })

                    res.vernacularNames.forEach(name => {
                        let fullName = this.getFullSpeciesName(name)
                        this.vernacularNames.push(fullName)
                    })

                    this.getHigherTaxonomy()


                }).catch((error) => {
                    console.log(API_ERROR_MESSAGE, error)
                })

            },

            getHigherTaxonomy() {
                this.higherTaxonomy = []
                // concatenate higher taxonomy classes of currently accepted name
                axios.get(speciesUrl.higherTaxonomyByGenus + this.currentNames[0].split(' ')[0]).then((result) => {
                    let res = result.data
                    this.higherTaxonomy.push(Object.values(res[0]).slice(1))

                }).catch((error) => {
                    console.log(API_ERROR_MESSAGE, error)
                })
            },

            getIndexFungorumInfo() {
                this.indexFungorumNames = []

                axios.get(speciesUrl.indexFungorumInfo + this.taxonId).then((result) => {
                    let res = result.data

                    let indexFungorumCurrentId = res[0].ifIdCurrent
                    let indexFungorumCurrentName = res[0].currentName

                    this.queryIndexFungorumURL = indexFungorumAPI.searchNameByID + indexFungorumCurrentId

                    this.indexFungorumNames.push(indexFungorumCurrentName  + ' (ID=' + indexFungorumCurrentId + ')')
                    if (indexFungorumCurrentId != null) {
                      this.showIndexFungorum = true
                    } else {
                      this.showIndexFungorum = false
                    }

                }).catch((error) => {
                    this.showIndexFungorum = false
                    console.log(API_ERROR_MESSAGE, error)
                })

            }
        },
        created() {
            this.getNameVariants()
            this.checkProtectionStatus()
            this.updateUrlParams()
            this.getIndexFungorumInfo()

        }

    }
</script>

<style scoped lang="scss">
    @import '../../../global';

    #icon-outside-timerange {
        color: $app-dark-yellow
    }

    #icon-within-timerange {
        color: $app-dark-red
    }

</style>